import { memo } from 'react'
import { useIntl } from 'react-intl'
import OfferCardCarouselSection, { MIN_OFFER_CAROUSEL_OFFERS_COUNT } from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { getSearchQueryFromFilter } from 'lib/search/searchUtils'
import { LOYALTY_STAY_UPGRADE_OFFER_LIST_FILTERS } from 'loyalty/constants/loyaltySearchFilters'

const VIEW_ALL_LINK = `/search?${getSearchQueryFromFilter(LOYALTY_STAY_UPGRADE_OFFER_LIST_FILTERS)}`

function SocieteStayUpgradeCarousel() {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'IKewHt4dCJYn3FiuKU1W',
    defaultMessage: 'Upgrade your stay for free with Société',
    description: 'Heading title for Société stay upgrade carousel on the homepage',
  })

  return (
    <OfferCardCarouselSection
      filters={LOYALTY_STAY_UPGRADE_OFFER_LIST_FILTERS}
      title={title}
      allLink={VIEW_ALL_LINK}
      tileStyle="card-default"
      tileSize="medium"
      minimumOffersCount={MIN_OFFER_CAROUSEL_OFFERS_COUNT}
      id="societe-stay-upgrade-carousel"
      data-testid="societe-stay-upgrade-carousel"
    />
  )
}

export default memo(SocieteStayUpgradeCarousel)
